import { Modal, Typography } from 'antd'
import Button from 'components/button/Button'

interface IProps {
  fetchStatusUpdateJobVacancy: 'loading' | 'idle'
  isOpen: boolean
  onCancel: () => void
  onConfirm: () => void
}

export default function ModalUpdateJobVacancyStatus(props: IProps) {
  const { fetchStatusUpdateJobVacancy, isOpen, onCancel, onConfirm } = props

  const loading = fetchStatusUpdateJobVacancy === 'loading'

  return (
    <Modal open={isOpen} footer={null} onCancel={onCancel} centered closeIcon={null}>
      <Typography.Paragraph className="text-center text-base text-[#333539] font-bold">
        Konfirmasi Perubahan Status Pekerjaan
      </Typography.Paragraph>
      <Typography.Paragraph className="text-center text-sm text-[#333539] font-normal">
        Anda akan mengubah status pekerjaan menjadi selesai
      </Typography.Paragraph>
      <div className="flex gap-2">
        <Button
          disabled={loading}
          loading={loading}
          block={true}
          onClick={onCancel}
          data-testid="button_cancel"
          className="inline-block text-primary font-bold border border-primary"
          label="Batal"
        />
        <Button
          disabled={loading}
          loading={loading}
          block={true}
          onClick={onConfirm}
          data-testid="button_confirm"
          className="inline-block font-bold"
          iconPosition="right"
          label="Konfirmasi"
          variant="solid-primary"
        />
      </div>
    </Modal>
  )
}
